import { Layer, Source } from 'react-map-gl/mapbox';
import useMap from '@alltrails/maps/hooks/useMap';
import { ConditionStyleId } from '@alltrails/maps/types/Styles';
import { conditionsOverlaysTopId, getLayerBeforeId } from '@alltrails/maps/utils/layers';
import { getOverlayTilesDateTimeString } from '../../utils/timeHelpers';

const apiKey = process.env.NEXT_PUBLIC_API_KEY!;

type ConditionOverylayProps = { activeCondition: Exclude<ConditionStyleId, 'groundConditions'>; isActive: boolean; maxZoom: number; utc: number };

const ConditionOverlay = ({ activeCondition, isActive, maxZoom, utc }: ConditionOverylayProps) => {
  const map = useMap();

  const sourceId = `${activeCondition}-${utc}-source`;
  const layerId = `${activeCondition}-${utc}-layer`;

  return (
    <Source
      id={sourceId}
      maxzoom={maxZoom}
      tiles={[
        `/wmts/weather/${getOverlayTilesDateTimeString(utc)}/${activeCondition}/{z}/{x}/{y}.webp?key=${apiKey}${activeCondition === 'snowDepth' ? '&snodas=true' : ''}`
      ]}
      tileSize={256}
      type="raster"
    >
      <Layer
        beforeId={getLayerBeforeId(map, conditionsOverlaysTopId)}
        id={layerId}
        paint={{ 'raster-opacity': isActive ? 0.55 : 0 }}
        source={sourceId}
        type="raster"
      />
    </Source>
  );
};

export default ConditionOverlay;
